import { QUIZ_TITLE_ERROR, QUIZ_RESUME_ERROR, QUIZ_LESSON_ERROR } from "constants/messages/error";

// eslint-disable-next-line import/prefer-default-export
export const errorMessage = {
  title: QUIZ_TITLE_ERROR,
  resume: QUIZ_RESUME_ERROR,
  lesson: QUIZ_LESSON_ERROR,
};
